"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FocusLockUI", {
  enumerable: true,
  get: function get() {
    return _Lock.default;
  }
});
Object.defineProperty(exports, "AutoFocusInside", {
  enumerable: true,
  get: function get() {
    return _AutoFocusInside.default;
  }
});
Object.defineProperty(exports, "MoveFocusInside", {
  enumerable: true,
  get: function get() {
    return _MoveFocusInside.default;
  }
});
Object.defineProperty(exports, "FreeFocusInside", {
  enumerable: true,
  get: function get() {
    return _FreeFocusInside.default;
  }
});
Object.defineProperty(exports, "InFocusGuard", {
  enumerable: true,
  get: function get() {
    return _FocusGuard.default;
  }
});
exports.default = void 0;

var _Lock = _interopRequireDefault(require("./Lock"));

var _AutoFocusInside = _interopRequireDefault(require("./AutoFocusInside"));

var _MoveFocusInside = _interopRequireDefault(require("./MoveFocusInside"));

var _FreeFocusInside = _interopRequireDefault(require("./FreeFocusInside"));

var _FocusGuard = _interopRequireDefault(require("./FocusGuard"));

var _default = _Lock.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-focus-lock/dist/cjs/UI.js
// module id = 2161
// module chunks = 0